import LoadingButton from '@zenbusiness/zui/LoadingButton';
import PropTypes from 'prop-types';

import FormStepModal from '#client/components/FormStepModal';

import CheckDepositIntro from './CheckDepositIntro';
import { DialogActionsStyled, DialogContentStyled } from './IntroCaptureBackImage.style';

const IntroCaptureBackImage = ({
  handleClose,
  isAutoCaptureMode,
  autoCaptureCheckImageBack,
  manualCaptureCheckImageBack,
  saveCapturedImageHandler
}) => {
  const takePhotoHandler = () => {
    if (isAutoCaptureMode) {
      autoCaptureCheckImageBack(saveCapturedImageHandler);
    } else {
      manualCaptureCheckImageBack(saveCapturedImageHandler);
    }
    handleClose();
  };

  return (
    <FormStepModal
      handleClose={handleClose}
      isHideBackButton
      title="Check deposit"
    >
      <DialogContentStyled>
        <CheckDepositIntro />
      </DialogContentStyled>
      <DialogActionsStyled>
        <LoadingButton
          color="primary"
          fullWidth
          onClick={takePhotoHandler}
          variant="contained"
        >
          I&apos;m ready
        </LoadingButton>
      </DialogActionsStyled>
    </FormStepModal>
  );
};

IntroCaptureBackImage.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isAutoCaptureMode: PropTypes.bool,
  autoCaptureCheckImageBack: PropTypes.func,
  manualCaptureCheckImageBack: PropTypes.func,
  saveCapturedImageHandler: PropTypes.func
};

export default IntroCaptureBackImage;
